// src/telas/login/index.tsx

import styles from "./styles.module.css";
import { Link, useNavigate } from "react-router-dom";

import logo from "../../assets/icon.png";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { GrGrommet, GrRadialSelected } from "react-icons/gr";
import { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { ContextRegister } from "../../context";
import { AuthFetchJson, url } from "../../api";
import { Utils } from "../../utils";

export function Login() {
  const navigate = useNavigate();
  const { dispatch } = useContext(ContextRegister);

  const [statusPassword, setStatusPassword] = useState(false);
  const [remember, setRemember] = useState(true);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");

  async function handleLogin() {
    let loginaux = login.replace(/\D/g, "");

    if (loginaux.length < 14 || senha === "") {
      if (Swal.isLoading()) {
        Swal.close();
      }

      Swal.fire({
        title: "Acesso",
        timer: 1500,
        allowOutsideClick: true,
        html: "Preencha todos os campos corretamente",
      });
      return;
    }

    Swal.fire({
      title: "Autenticaçao!",
      html: "Aguarde, entrando no sistema.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (remember) {
      localStorage.setItem(
        "authentication_p",
        JSON.stringify({
          login,
          senha,
        }),
      );
    } else {
      localStorage.removeItem("authentication_p");
    }

    AuthFetchJson(`${url}FORNECEDORLOGIN`, {
      body: JSON.stringify({
        LOGIN: loginaux,
        SENHA: senha,
        ZTIPFOR: "P",
      }),
      method: "POST",
    })
      .then((responseJson) => {
        if (responseJson.sucesso === "T") {
          dispatch({
            type: "usuario",
            payload: responseJson.dados[0],
          });

          localStorage.setItem(
            "usuario",
            JSON.stringify(responseJson.dados[0]),
          );
          localStorage.setItem("IPEST-TOKEN", responseJson.dados[0].TOKEN);

          navigate("/home");
        }

        if (responseJson.sucesso === "F") {
          localStorage.removeItem("usuario");

          Swal.fire({
            title: "Autenticaçao!",
            html: "Acesso incorreto.",
          });
        }
      })
      .catch((err) => {
        localStorage.removeItem("usuario");

        Swal.fire({
          title: "Autenticaçao!",
          html: "Erro ao entrar no sistema, tente novamente e se persistir entre em contato com o administrador.",
        });

        console.log(err);
      })
      .finally(() => {
        if (Swal.isLoading()) {
          Swal.close();
        }
      });
  }

  useEffect(() => {
    if (login === "" && senha === "") {
      let auth: any = localStorage.getItem("authentication_p");

      console.log(auth);

      if (auth) {
        auth = JSON.parse(auth);

        setLogin(auth.login);
        setSenha(auth.senha);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      {/* DECORAÇÃO NAS EXTREMIDADES */}
      <div className={styles.blobTopRight} aria-hidden="true" />
      <div className={styles.blobBottomLeft} aria-hidden="true" />

      <div className={styles.panel}>
        {/* LADO ESQUERDO */}
        <div className={styles.brandSide}>
          <img src={logo} className={styles.logo} alt="Ipest logo" />
          <p className={styles.brandTagline}>
            A plataforma para prestação de serviço descomplicada de proteção
            contra pragas.
          </p>
          <ul className={styles.featureList}>
            <li>✓ Gestão de ordens de serviço</li>
            <li>✓ Controle de técnicos</li>
            <li>✓ Relatórios em tempo real</li>
          </ul>
        </div>

        {/* LADO DIREITO */}
        <div className={styles.formSide}>
          <div className={styles.formHeader}>
            <h2 className={styles.formTitle}>Acesso Parceiro</h2>
            <p className={styles.formSubtitle}>
              Entre com suas credenciais para acessar a plataforma.
            </p>
          </div>

          {/* CNPJ */}
          <div className={styles.inputGroup}>
            <label htmlFor="cnpj">CNPJ</label>
            <input
              id="cnpj"
              value={login}
              onChange={(event) =>
                setLogin(Utils.maskaraCnpj(event.target.value))
              }
              placeholder="00.000.000/0000-00"
              type="text"
            />
          </div>

          {/* SENHA */}
          <div className={styles.inputGroup}>
            <label htmlFor="senha">Senha</label>
            <div className={styles.passwordWrapper}>
              <input
                id="senha"
                value={senha}
                onChange={(event) => setSenha(event.target.value)}
                placeholder="••••••"
                type={statusPassword ? "text" : "password"}
              />
              <button
                type="button"
                className={styles.eyeBtn}
                onClick={() => setStatusPassword(!statusPassword)}
                aria-label={statusPassword ? "Ocultar senha" : "Mostrar senha"}
              >
                {statusPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </button>
            </div>
            <sub>6 ou mais caracteres</sub>
          </div>

          <div className={styles.rememberRow}>
            <div className={styles.rememberToggle}>
              <button
                type="button"
                className={styles.toggleBtn}
                onClick={() => setRemember(!remember)}
                aria-label="Lembrar de mim"
              >
                {remember ? <GrRadialSelected /> : <GrGrommet />}
              </button>
              <span>Lembrar de mim</span>
            </div>
            <Link to={"relembrar"} className={styles.forgotLink}>
              Esqueci minha senha
            </Link>
          </div>

          <button className={styles.submitBtn} onClick={handleLogin}>
            Entrar na conta
          </button>

          <p className={styles.registerPrompt}>
            Ainda não tem conta?{" "}
            <Link to={"/cadastro-formulario"}>Cadastre-se</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
